var __jsx = React.createElement;
import getFromCdn from '@anm/helpers/getFromCdn';
import React from 'react';
import { Badge, MuteIcon, Wrapper } from './Wrapper';

var TapToUnmute = function TapToUnmute(_ref) {
  var onClick = _ref.onClick;
  return __jsx(Wrapper, {
    onClick: onClick
  }, __jsx(Badge, null, __jsx(MuteIcon, {
    src: getFromCdn('images/icons/sound-off.svg')
  }), "Tap to unmute"));
};

export default TapToUnmute;